import { Component, OnDestroy, OnInit } from '@angular/core'
import { BreadcrumbService } from '../../common/services/breadcrumb.service'
import { BreadcrumbLink } from '../../common/interfaces/breadcrumb-link.interface'
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {
  breadcrumbLinks: BreadcrumbLink[];
  subscription: Subscription;

  constructor(private breadcrumbService: BreadcrumbService) {}

  ngOnInit() {
    this.breadcrumbLinks = [];
    this.subscription = this.breadcrumbService.breadcrumbLinks.subscribe(
      (newValue: BreadcrumbLink[]) => {
        this.breadcrumbLinks = newValue
      }
    )
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
